import { makeRequest } from '@services/requests/makeRequest';
import { PUBLIC_API_KEYS } from '@services/requests/requestResources';

export const getPublicApiKey = () => makeRequest('GET', `${PUBLIC_API_KEYS}`);
